import { Tooltip } from '@civilgrid/ui/components';
import { useParams } from '@tanstack/react-router';
import { useSnapshot } from 'valtio';
import { captureTypedPosthogEvent, POSTHOG_EVENTS } from '~/common/posthogEvents';
import Button from '~/components2/forms/Button';
import type { ProjectDetailsParams } from '~/pages/projectDetails';
import rootStore from '~/store';
import store from './store';

interface Props {
  visible?: boolean;
}

export default function SplitView({ visible }: Props) {
  const { splitView } = useSnapshot(store);
  const params = useParams({ strict: false }) as ProjectDetailsParams;

  if (!visible) {
    return null;
  }

  return (
    <div className="z-10">
      <Tooltip asChild side="right" sideOffset={10} text="Split view">
        <Button
          alternate
          icon={splitView ? 'chevronLeft' : 'layoutSplit'}
          size="icon"
          iconSize={14}
          aria-label="Split view"
          aria-pressed={splitView}
          data-testid="split-view-toggle"
          onClick={() => {
            const value = !splitView;
            store.setSplitView(value);

            if (params.projectId) {
              captureTypedPosthogEvent(POSTHOG_EVENTS.projectMapViewToggled, {
                project_id: params.projectId,
                organization_id: rootStore.currentOrganizationId || undefined,
                source: 'project_details',
                from: splitView ? 'split' : 'map',
                to: value ? 'split' : 'map',
              });
            }
          }}
        />
      </Tooltip>
    </div>
  );
}
